const hasHtmlEntity = (value: string) =>
	/&(?:lt|gt|amp|quot|apos|#39|#x27);/i.test(value);

export const decodeHtmlEntities = (value: string): string => {
	if (!hasHtmlEntity(value)) {
		return value;
	}

	if (typeof document !== 'undefined') {
		const textarea = document.createElement('textarea');
		textarea.innerHTML = value;
		return textarea.value;
	}

	return value
		.replace(/&lt;/gi, '<')
		.replace(/&gt;/gi, '>')
		.replace(/&quot;/gi, '"')
		.replace(/&apos;|&#39;|&#x27;/gi, "'")
		.replace(/&amp;/gi, '&');
};

export const decodePostHtmlContent = <T extends Record<string, any> | null>(post: T): T => {
	if (!post?.mainOutcome) {
		return post;
	}

	const decodeMaybeString = (value: unknown) =>
		typeof value === 'string' ? decodeHtmlEntities(value) : value;
	const decodeMainText = (mainText: unknown) =>
		Array.isArray(mainText)
			? mainText.map((section) => {
				if (!section || typeof section !== 'object') {
					return section;
				}

				return {
					...section,
					heading: decodeMaybeString(section?.heading),
					content: decodeMaybeString(section?.content)
				};
			})
			: mainText;

	return {
		...post,
		mainOutcome: {
			...post.mainOutcome,
			author: decodeMaybeString(post.mainOutcome.author),
			leadText: decodeMaybeString(post.mainOutcome.leadText),
			keyMessages: decodeMaybeString(post.mainOutcome.keyMessages),
			main_text: decodeMainText(post.mainOutcome.main_text)
		},
		mainOutcomeBl: post.mainOutcomeBl
			? {
					...post.mainOutcomeBl,
					author: decodeMaybeString(post.mainOutcomeBl.author),
					leadText: decodeMaybeString(post.mainOutcomeBl.leadText),
					keyMessages: decodeMaybeString(post.mainOutcomeBl.keyMessages),
					main_text: decodeMainText(post.mainOutcomeBl.main_text)
				}
			: post.mainOutcomeBl
	} as T;
};
